import { FuseRouteItemType, FuseRoutesType } from "@fuse/utils/FuseUtils";
import { Navigate } from "react-router";
import FuseLoading from "@fuse/core/FuseLoading";
import ErrorBoundary from "@fuse/utils/ErrorBoundary";
import { layoutConfigOnlyMain } from "../layoutConfigTemplates";
import settingsConfig from "../config-definicao";
import App from "@/app/App";
import { IndexView } from "@/app/(protected)";
import { APP_ROUTE_ITEMS } from "./app-rotas";

const namedRouteConfigModules: Record<string, unknown> = import.meta.glob("/src/app/**/*Route.tsx", {
	eager: true,
});

const routeConfigModules: Record<string, unknown> = import.meta.glob(
	["/src/app/**/route.tsx", "!/src/app/(protected)/apps/**/route.tsx"],
	{
		eager: true,
	},
);

const allConfigModules = { ...namedRouteConfigModules, ...routeConfigModules };

const systemRoutes: FuseRouteItemType[] = Object.keys(allConfigModules).flatMap((modulePath) => {
	const moduleConfigs = (
		allConfigModules[modulePath] as {
			default: FuseRouteItemType | FuseRouteItemType[];
		}
	).default;
	return moduleConfigs;
});

const routes: FuseRoutesType = [
	{
		path: "/",
		element: <App />,
		auth: settingsConfig.defaultAuth,
		errorElement: <ErrorBoundary />,
		children: [
			{
				path: "/",
				element: <IndexView />,
			},
			{
				path: "index.html",
				element: <Navigate to="/" replace />,
			},
			...APP_ROUTE_ITEMS,
			...systemRoutes,
			{
				path: "loading",
				element: <FuseLoading />,
				settings: { layout: layoutConfigOnlyMain },
			},
		],
	},
	{
		path: "*",
		element: <Navigate to="/404" />,
	},
];

export default routes;
